export default class Logger {
    static log(text){
      var time = new Date();
      console.log("[" + time.toLocaleTimeString() + "] " + text);
    }
}


// WEBPACK FOOTER //
// ./src/fscommon/utils/logger.js